// Wegen SonarQube Major issue alle magic-numbers ersetzt
const TWO = 2;
const THREE = 3;
const FOUR = 4;
const SIX = 6;
const EIGHT = 8;
const FIFTY = 50;
const HUNDRED = 100;

// @dynamic
export class DateConverter {
    /**
     * Converting some user inputs to a valid date format  in format 'DD.MM.YYYY'
     */
    public static convert(value: string): string {
        return this.isStringAndContainsDotsAndDigits(value) ? this.convertValidDate(value) : value;
    }

    /**
     * Converting some user inputs to a valid date format  in format 'MM.YYYY'
     */
    public static convertMonthYear(value: string): string {
        return this.isStringAndContainsDotsAndDigits(value) ? this.convertValidDateMonthYear(value) : value;
    }

    private static isStringAndContainsDotsAndDigits(value: string): boolean {
        return typeof value === 'string' && value.length > 0 && RegExp('^[.0-9 ]+$').test(value);
    }

    private static twoDots(value) {
        return value.split('.').length - 1 === TWO || value.indexOf('.') === -1;
    }

    private static convertValidDate(value: string) {
        let newVal = value.replace(/ +/g, '');

        if ([FOUR, SIX, EIGHT].indexOf(newVal.length) === -1 || !DateConverter.twoDots(newVal)) {
            return value;
        }

        newVal = this.convertInputWithoutDots(newVal);
        const year = newVal.split('.')[TWO];
        const month = newVal.split('.')[1];
        let day = newVal.split('.')[0];

        // YEAR
        if ([TWO, FOUR].indexOf(year.length) === -1 || Number(year) <= 0) {
            return value;
        }

        if (day.length > TWO || month.length > TWO) {
            return value;
        }

        // convert day
        day = day.length === 1 ? `0${day}` : day;
        return `${day}.${this.convertMonth(month)}.${this.convertYear(year)}`;
    }

    private static convertValidDateMonthYear(value: string) {
        let newVal = value.replace(/ +/g, '');

        if ([THREE, FOUR, SIX].indexOf(newVal.length) === -1 || !DateConverter.twoDots(newVal)) {
            return value;
        }

        newVal = this.convertInputWithoutDotsMonthYear(newVal);
        const year = newVal.split('.')[1];
        const month = newVal.split('.')[0];

        // year
        if ([TWO, FOUR].indexOf(year.length) === -1 || Number(year) <= 0) {
            return value;
        }

        if (month.length > TWO) {
            return value;
        }

        return `${this.convertMonth(month)}.${this.convertYear(year)}`;
    }

    /**
     * month has length 2
     */
    private static convertMonth(month) {
        return month.length === 1 ? `0${month}` : month;
    }

    private static convertYear(year) {
        if (year.length === TWO) {
            // year.length === TWO
            if (Number(year) >= 0 && Number(year) < FIFTY) {
                // 00-49 --> 2049
                year = `20${year}`;
            } else if (Number(year) >= FIFTY && Number(year) < HUNDRED) {
                // 50-99 --> 2050
                year = `19${year}`;
            }
        }
        return year;
    }

    /**
     * return format dd.mm.yyyy
     */
    private static convertInputWithoutDots(newVal) {
        if (newVal.indexOf('.') === -1) {
            // no dots
            if (newVal.length === FOUR) {
                newVal = `${newVal.substring(0, 1)}.${newVal.substring(1, TWO)}.${newVal.substring(TWO, FOUR)}`;
            } else if (newVal.length === SIX) {
                newVal = `${newVal.substring(0, TWO)}.${newVal.substring(TWO, FOUR)}.${newVal.substring(FOUR, SIX)}`;
            } else if (newVal.length === EIGHT) {
                newVal = `${newVal.substring(0, TWO)}.${newVal.substring(TWO, FOUR)}.${newVal.substring(FOUR, EIGHT)}`;
            }
        }
        return newVal;
    }

    /**
     * return format mm.yyyy
     */
    private static convertInputWithoutDotsMonthYear(newVal) {
        if (newVal.indexOf('.') === -1) {
            // no dots
            if (newVal.length === THREE) {
                newVal = `${newVal.substring(0, 1)}.${newVal.substring(1, THREE)}`;
            } else if (newVal.length === FOUR) {
                newVal = `${newVal.substring(0, TWO)}.${newVal.substring(TWO, FOUR)}`;
            } else if (newVal.length === SIX) {
                newVal = `${newVal.substring(0, TWO)}.${newVal.substring(TWO, SIX)}`;
            }
        }
        return newVal;
    }
}
